import appGlobalScript from '/home/runner/work/safety/safety/website/extensions/nxuvex/Resources/Private/App/src/global/styleguide.ts';
export const globalScripts = appGlobalScript;
export const globalStyles = "";
